import { NavLink } from "react-router-dom"
const Footer = () => {
    return (
        <>
            <div className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ul className="footer-menu">
                                <li><a href="#">PRESCHOOL ADMISSION</a></li>
                                <li><a href="#">CENTER LOCATOR</a></li>
                                <li><a href="#">FRANCHISEE OPPORTUNITY</a></li>
                                <li><a href="#">CONTACT US</a></li>
                                <li><a href="#">LOGIN</a></li>
                                <li><a href="#">TERMS OF USE</a></li>
                                <li><a href="#">SITEMAP</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <p>©️ Copyright 2017-2026 SMNS School. All Right Reserved | <a href="https://www.entab.in/" target="_blank">Created By Entab Infotech : CampusCare®️ </a> </p>
            </div>
        </>
    )
}
export default Footer